import { PipeTransform, Signal, computed } from '@angular/core';
import { select } from '@ngxs/store';
import { LocalizationState } from '../state/localization.state';
import { LocalizedDateTimeFormatKey } from '../types/localization-setting';
import { toLocalizedDateTimeFormat } from '../utils/localized-date-time-format';
import { BaseLocalizedPlaceholderFormatPipe } from './base-localized-placeholder-format.pipe';

export type BaseLocalizedDateTimeFormatParams =
  | string
  | Date
  | number
  | null
  | undefined;

export abstract class BaseLocalizedDateTimeFormatPipe
  extends BaseLocalizedPlaceholderFormatPipe<BaseLocalizedDateTimeFormatParams>
  implements PipeTransform
{
  private readonly localizationSetting = select(
    LocalizationState.getLocalizationSetting,
  );
  private readonly dateFnsLocale = select(LocalizationState.getDateFnsLocale);

  protected abstract readonly formatType: LocalizedDateTimeFormatKey;

  transform(value: BaseLocalizedDateTimeFormatParams): string {
    if (!value) {
      return '';
    } else {
      return toLocalizedDateTimeFormat(
        value,
        this.localizationSetting(),
        this.formatType,
        this.dateFnsLocale(),
      );
    }
  }

  toFormattedSignal(value: BaseLocalizedDateTimeFormatParams): Signal<string> {
    return computed(() => this.transform(value));
  }

  protected getPlaceholderInput(): Date {
    return new Date();
  }
}
